module.exports = __webpack_public_path__ + "static/media/meat.bfb4e51b.svg";